// extracted by mini-css-extract-plugin
module.exports = {"bulletedList":"styles_bulletedList__4-XVn","reviewAndSignButtonText":"styles_reviewAndSignButtonText__zZlq1"};